import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';
import React, { useEffect } from 'react';
import VideoPlayer from '../../../components/VideoPlayer';
import { formatPhone } from '../utils';

const Root = styled('div')`
  margin: auto;
  text-align: center;
`;

const ThankYou = ({ contact, settings, logoUrl }) => {
  const {
    confirmation_video_url,
    confirmation_message,
    confirmation_custom_url,
  } = settings;
  useEffect(() => {
    if (confirmation_custom_url) {
      setTimeout(() => {
        window.location.replace(confirmation_custom_url);
      }, 4000);
    }
  }, []);

  const phone = formatPhone(contact.primary_phone);
  const email = contact.contact_email;
  let contactInfo;
  if (!phone && email) {
    contactInfo = `Our records show your email is ${email}`;
  } else if (phone && !email) {
    contactInfo = `Our records show your cell phone is ${phone}`;
  } else if (phone && email) {
    contactInfo = `Our records show your email is ${email} and your cell phone is ${phone}`;
  }

  return (
    <Root>
      <Box>
        {confirmation_video_url && !confirmation_custom_url && (
          <VideoPlayer url={confirmation_video_url} />
        )}
      </Box>
      <Typography paragraph variant="subtitle1" fontWeight={700}>
        {confirmation_message ||
          `Thanks ${contact.contact_first_name}! We’ll be in touch.`}
      </Typography>
      {contactInfo && <Typography>{contactInfo}</Typography>}
      {confirmation_custom_url && (
        <Typography paragraph variant="caption">
          Redirecting you to {confirmation_custom_url}
        </Typography>
      )}
    </Root>
  );
};

export default ThankYou;
